import React from 'react';
import styled from 'styled-components';
import Link from 'components/_utility/Link/Link';
import RichText from 'components/_utility/RichText/RichText';
import { minBp } from 'src/lib/theme';

// Stop styled-components passing primary prop into Link
const _Link = ({ primary, ...props }) => <Link {...props} />; // eslint-disable-line

export const Wrap = styled.div`
  ${({ isListingsPage, listView }) => `
    background-color: white;
    box-shadow: 0 0 32px 0 rgba(0, 0, 0, 0.1);
    width: 100%;
    animation-name: fadeIn;
    animation-duration: 0.5s;
    animation-fill-mode: forwards;
    will-change: opacity;
    opacity: 0;
    display: flex;
    flex-direction: column;

    @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
      display: block;
    }

    @keyframes fadeIn {
      from {
        opacity: 0;
      }

      to {
        opacity: 1;
      }
    }

    ${
      isListingsPage
        ? `
      @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
        max-width: calc(25% - 32px);
        margin: 0 16px 32px;

        ${
          listView
            ? `      
            max-width: 100%;
            margin: 0 0 32px;
            display: flex;
        `
            : ``
        }
      }

    `
        : ``
    }

    ${
      listView
        ? `
      @media ${minBp('tabletLarge')} {
        height: 215px;
        margin-bottom: 32px;
        flex-direction: row;
      }
    `
        : ``
    }
  `}
`;

export const ImageWrap = styled(_Link)`
  ${({ listView }) => `
    border-bottom: ${listView ? 'none' : '1px solid #e0e0e0'};
    height: ${listView ? 'auto' : '150px'};
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    ${
      listView
        ? `
      @media ${minBp('tabletLarge')} {
        flex: 1;
        border-right: 1px solid #e0e0e0;
      }
    `
        : ``
    }
  `}
`;

export const Image = styled.img`
  display: block;
  max-height: 110px;
`;

export const Content = styled.div`
  ${({ isListingsPage, listView }) => `  
    padding: ${isListingsPage ? '35px 35px 30px' : '35px'};
    height: ${isListingsPage ? 'auto' : '250px'};
    overflow: hidden;
    flex: 1;

    @media ${minBp('tabletLarge')} {
      height: 250px;
    }

    ${
      listView
        ? `
      @media ${minBp('tabletLarge')} {
        height: auto;
        border-right: 1px solid #e0e0e0;
        padding: 30px 50px;
      }
    `
        : ``
    }
  `}
`;

export const Name = styled.h4`
  ${({ listView }) => `
    text-transform: uppercase;
    text-align: ${listView ? 'left' : 'center'};
    margin-bottom: 10px;
  `}
`;

export const PriceWrapper = styled.div`
  ${({ listView }) => `
  display: flex;
  align-items: center;
  justify-content: ${listView ? 'flex-start' : 'center'};
  gap: 4px;
  margin-bottom: 5px;
  `}
`;

export const Price = styled.div`
  ${({ listView }) => `
    text-align: ${listView ? 'left' : 'center'};
    font-weight: 500;
    font-family: ${({ theme }) => theme.fonts.dinDemi};
    color: black;
  `}
`;

export const InfoCircleWrap = styled.button`
  display: inline-flex;
  align-items: center;
  background: transparent;
  border: none;
  cursor: pointer;
  vertical-align: middle;
  padding: 0;
  margin-left: 3px;

  @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
    position: relative;
    top: 2px;
  }

  svg {
    height: 16px;
    width: 16px;
    padding-bottom: 2px;

    @media ${minBp('tabletLarge')} {
      height: 20px;
      width: 18px;
    }

    path {
      fill: #2a2a2a;
    }
  }
`;

export const Description = styled(RichText)`
  ${({ isListingsPage }) => `  
    font-size: 14px;
    max-height: 92px;
    display: ${isListingsPage ? 'none' : 'block'};

    @media ${minBp('tabletLarge')} {
      display: block;
    }

    ul {
      margin: 0;
      padding: 0;
      padding-left: 16px;
    }

    li {
      padding: 3px 0;
    }
  `}
`;

export const Actions = styled.div`
  border-top: 1px solid #e0e0e0;
  padding: 10px 0;
  display: flex;
`;

export const Divider = styled.div`
  width: 1px;
  height: 43px;
  background-color: #e0e0e0;
`;

export const Action = styled(_Link)`
  font-family: ${({ theme }) => theme.fonts.dinRegular};
  height: 43px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  flex: 1;
  appearance: none;
  color: black;
  font-size: 15px;
  background-color: white;
  border: 0;
  cursor: pointer;
  text-decoration: none;
  text-align: center;

  ${({ primary, theme }) =>
    primary
      ? `
    font-family: ${({ theme }) => theme.fonts.dinDemi};
    color: ${theme.colors.buttons.primary};
    font-weight: 500;
  `
      : ``}

  &:focus {
    background-color: #fafafa;
  }
`;

export const ActionLink = styled.a`
  font-family: ${({ theme }) => theme.fonts.dinRegular};
  height: 43px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  flex: 1;
  appearance: none;
  color: black;
  font-size: 15px;
  background-color: white;
  border: 0;
  cursor: pointer;
  text-decoration: none;
  text-align: center;

  ${({ primary, theme }) =>
    primary
      ? `
    font-family: ${({ theme }) => theme.fonts.dinDemi};
    color: ${theme.colors.buttons.primary};
    font-weight: 500;
  `
      : ``}

  &:focus {
    background-color: #fafafa;
  }
`;

export const MainContent = styled.div`
  ${({ listView }) => `
    flex: 1;

    ${
      listView
        ? `
      @media ${minBp('tabletLarge')} {
        display: flex;
        flex: 2;
      }
    `
        : ``
    }
  `}
`;

export const AdditionalContent = styled.div`
  ${({ listView }) => `
    ${
      listView
        ? `
      @media ${minBp('tabletLarge')} {
        flex: 1;
        display: flex;
        flex-direction: column;
      }
    `
        : ``
    }
  `}
`;

export const DetailedDescription = styled.div`
  ${({ listView }) => `
    display: none;

    ${
      listView
        ? `
      @media ${minBp('tabletLarge')} {
        display: block;
        flex: 1;
        padding: 30px 50px;
        font-size: 14px;
        line-height: 1.375;
      }
    `
        : ``
    }
  `}
`;
